import axios from "axios";
import { IResponse, IWatchList } from "..";

export interface IWatchListApi {
  watchlistEndpoint: string;
  get: (network: string, wallet: string, authToken: string) => Promise<IResponse<IWatchList>>;
  addPair: (network: string, wallet: string, pairId: number, authToken: string) => Promise<any>;
  remove: (network: string, wallet: string, pairId: number, authToken: string) => Promise<any>;
}

export class WatchListApi implements IWatchListApi {
  watchlistEndpoint: string;

  constructor(apiGateway: string) {
    if (!apiGateway) {
      apiGateway = 'https://api.kattana.trade';
    }

    this.watchlistEndpoint = `${apiGateway}/watchlist`;
  }


  public get = async (network: string, wallet: string, authToken: string): Promise<IResponse<IWatchList>> => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` }
      };
      const res = await axios.get(`${this.watchlistEndpoint}/${network}/${wallet}`, config);

      return {
        success: true,
        data: res.data,
      };
    } catch (err) {
      console.warn(err);

      if (axios.isAxiosError(err)) {
        return {
            success: false,
            error: err
          };
      }

      return {
        success: false 
      };
    }
  }

  public addPair = async (network: string, wallet: string, pairId: number, authToken: string): Promise<any> => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` }
      };
      const res = await axios.post(`${this.watchlistEndpoint}/${network}/${wallet}/${pairId}`, {}, config);

      return {
        success: true,
        data: res.data,
      };
    } catch (err) {
      console.warn(err);

      if (axios.isAxiosError(err)) {
        return {
            success: false,
            error: err
          };
      }

      return {
        success: false 
      };
    }
  }

  public remove = async (network: string, wallet: string, pairId: number, authToken: string): Promise<any> => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` }
      };
      const res = await axios.delete(`${this.watchlistEndpoint}/${network}/${wallet}/${pairId}`, config);

      return {
        success: true,
        data: res.data,
      };
    } catch (err) {
      console.warn(err);

      if (axios.isAxiosError(err)) {
        return {
            success: false,
            error: err
          };
      }

      return {
        success: false 
      };
    }
  }
}